import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import MenuCM from "components/shared/menu";
import ProfileMenuCM from "components/profilemenu";
import FooterCM from "components/shared/footer";
import Container from "@mui/material/Container";
import Paper from "@mui/material/Paper";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import CardContent from "@mui/material/CardContent";
import PaginationCM from "components/shared/Pagination";
import ContactCM from "components/contactus";
import {
  StyledCardContent,
  StyledCard,
  StyledTypography,
  StyledNewMessage,
  StyledCardActions,
  StyledContainer,
} from "./Message.style";
import { getNotificationRequest } from "api/requests";
import useHttp from "hooks/use-http";
import { PAGINATION_LIMIT } from "constants";
import LoadingCM from "components/shared/Loading";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import Button from "@mui/material/Button";
import {Helmet} from "react-helmet";

export default function Messages() {
  const { request, loading } = useHttp();
  const [messages, setMessages] = useState({ data: [], count: 0 });
  const [page, setPage] = useState(1);

  const getMessages = useCallback(async () => {
    const res = await request({
      url: getNotificationRequest,
      values: {
        skip: (page - 1) * PAGINATION_LIMIT,
        limit: PAGINATION_LIMIT,
        type: "message",
      },
    });

    let transformedData = res.data.map((items) => ({
      id: items.notification_id,
      notification: items?.notification?.message,
      date: items?.notification?.created_at?.string,
      is_seen: items.is_seen,
    }));

    setMessages({ data: transformedData, count: res.count });
  }, [page, request]);

  useEffect(() => {
    getMessages();
  }, []);

  return (
    <>
      {loading && <LoadingCM />}
      <Helmet>
        <title>پیام های من - مبلمان ویول</title>
        <meta name="product_id" content={""} />
        <meta name="product_name" content={""} />
        <meta name="product_price" content={""} />
        <meta name="product_old_price" content={""} />
        <meta name="availability" content={""} />
        <meta property="og:image" content={""} />
      </Helmet>
      <MenuCM Background pageTitle="پیام های من" />
      <Container>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12} md={3} lg={3}>
            <ProfileMenuCM />
          </Grid>
          <Grid item xs={12} sm={12} md={9} lg={9} mb={10}>
            <Paper p={2}>
              <StyledCardContent>
                <Typography
                  variant="body2"
                  sx={{
                    fontSize: "21px",
                  }}
                >
                  پیام های من
                </Typography>
              </StyledCardContent>
              <CardContent>
                {messages.count < 1 ? (
                  <div style={{ textAlign: "center", padding: "28px" }}>
                    پیامی یافت نشد
                  </div>
                ) : (
                  <StyledContainer pb={2} spacing={2} mt={2}>
                    {messages.data.map((items, index) => (
                      <StyledCard key={"card" + index}>
                        {items.is_seen == false ? (
                          <StyledNewMessage>پیام جدید</StyledNewMessage>
                        ) : (
                          ""
                        )}
                        <CardContent>
                          <Typography
                            sx={{ fontSize: 14 }}
                            color="text.secondary"
                            gutterBottom
                          >
                            {index + 1}
                          </Typography>
                          <StyledTypography variant="body2">
                            {items.notification}
                          </StyledTypography>
                        </CardContent>
                        <StyledCardActions style={{ direction: "ltr" }}>
                          <Link
                            to={`/message/${items.id}`}
                            key={"list" + index}
                          >
                            <Button size="small">
                              <KeyboardArrowLeftIcon /> مشاهده پیام
                            </Button>
                          </Link>
                          <Typography
                            sx={{ fontSize: 14 }}
                            color="text.secondary"
                            gutterBottom
                          >
                            {items.date}
                          </Typography>
                        </StyledCardActions>
                      </StyledCard>
                    ))}
                    <Grid container my={2} spacing={1}>
                      <Grid item xs={12}>
                        <PaginationCM
                          handleChange={(e, val) => setPage(val)}
                          page={page}
                          limit={PAGINATION_LIMIT}
                          count={messages.count}
                        />
                      </Grid>
                    </Grid>
                  </StyledContainer>
                )}
              </CardContent>
            </Paper>
          </Grid>
        </Grid>
      </Container>
      <ContactCM All />
      <FooterCM />
    </>
  );
}
